import { useState, useEffect, useMemo, useRef } from "react";
import { FieldValidation } from "common/functions";
import OrderService from "api/precision/OrderService";
import AddressService from "api/precision/AddressService";
import CreditCardMonthYear from "controls/CreditCardMonthYear";
import CreditCardNumber from "controls/CreditCardNumber";

import Pagination from "controls/Pagination";
import CartItem from "./CartItem";
import CartDelivery from "./CartDelivery";
import CartPayment from "./CartPayment";
import CartTotal from "./CartTotal";
import CartPreview from "./CartPreview";
import CartService from "api/precision/CartService";
import ConfirmModal from "controls/ConfirmModal";
import ConfirmToast from "controls/ConfirmToast";
import { money } from "common/functions"
import 'styles/scora.css';

/**
 * Cart Item - {
 *   "id": res.data.data,
 *   "user_id": props.user.id,
 *   "product_id": props.product.id,
 *   "product_name": props.product.name,
 *   "quantity": preorderInfo.quantity
 * }
 */
export default function Checkout(props) {
  document.title = 'Shopping Cart';

  const placeOrderBtn = useRef();
  const formSectionRef = useRef(null);

  const { cartItems, emptyCart, getTotals } = props.useShoppingCart();
  const { getProfile, getCustomer } = props.useSession();
  const { navigate, location } = props.useRouter();
  const [user] = useState(getProfile());

  // cart, delivery, payment, preview
  const hash = location.hash !== "" ? location.hash.substring(1) : "cart";
  const [companyLogo, setCompanyLogo] = useState('');
  const [confirmation, setConfirmation] = useState({});
  const [toastMessage, setToastMessage] = useState({});
  const [rowPerPage, setRowPerPage] = useState(5);
  const [pageNumber, setPageNumber] = useState(0);

  // User information
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [clubName, setClubName] = useState("");
  const [county, setCounty] = useState("");
  const [line1, setLine1] = useState("");
  const [line2, setLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [cardNumber, setCardNumber] = useState("");
  const [expiration, setExpiration] = useState("");
  const [cvc, setCvc] = useState("");
  const [taxRate, setTaxRate] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);

  useEffect(() => {

  }, []);

  const validateForm = () => {
    const frm = FieldValidation(["firstName", "lastName", "county", "line1", "line2", "city",
      "state", "zipcode", "phone", "email", "cardNumber", "expiration", "cvc"]);
    return frm.result;
  }

  const placeOrder = (ev) => {
    ev.stopPropagation();
    // ev.target.disabled = true;

    const ok = validateForm();
    if (!ok) {
      formSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    placeOrderBtn.current.disabled = true;

    // Place order now
    OrderService.scoraPlaceOrder({
      "identity": "9f8b33bfa8cc28fa1e60fd242201b41f",
      "firstName": firstName,
      "lastName": lastName,
      "county": county,
      "clubName": clubName,
      "line1": line1,
      "line2": line2,
      "city": city,
      "state": state,
      "zipcode": zipcode,
      "phone": phone,
      "email": email,
      "cardNumber": cardNumber.replace(/[\s-]/g, ""),
      "expiration": expiration,
      "cvc": cvc,
      "items": cartItems
    }).then((res) => {
      if(res.data.result == 1) {
        emptyCart();
        navigate("/scora/orderConfirmed");
      }
      else {
        alert(res.data.data);
      }
    });

    placeOrderBtn.current.disabled = false;
  }

  const paginate = (type, pageId) => {
    setPageNumber(pageId);
  }

  const cartHeader = useMemo(() => {
    let cartTitle = "Shopping cart";
    if (hash == "preview") {
      cartTitle = "Order preview";
    }
    else if (hash == "delivery") {
      cartTitle = "Delivery information";
    }
    else if (hash == "payment") {
      cartTitle = "Payment information";
    }
    else if (hash == "preview") {
      cartTitle = "Order preview";
    }

    return <section className="d-flex justify-content-between align-items-center p-3 bg-secondary-subtle shadow">
      <h1 className="ps-5" style={{ fontSize: "35px" }}>{cartTitle}</h1>
    </section>
  });

  const getUnitPrice = (qnty) => {
    switch (parseInt(qnty)) {
      case 4: case 5: case 6: case 7:
        return 57.28;
      case 8: case 9: case 10: case 11:
        return 30.52;
      case 12: case 13: case 14: case 15:
        return 21.60;
      case 16: case 17: case 18: case 19:
        return 17.14;
      case 20: case 21: case 22: case 23:
        return 14.46;
      case 24: case 25: case 26: case 27:
        return 12.17;
      case 28: case 29: case 30: case 31:
        return 10.96;
      case 32:
        return 10.96;
      default:
        return 10.96;
    }
  }

  const cartSubTotal = useMemo(() => {
    let subTotal = 0.0;
    cartItems.map((item) => {
      subTotal = subTotal + (item.quantity * getUnitPrice(item.quantity));
    });
    return subTotal;
  });


  const handleZipcodeChange = (ev) => {
    const zip = ev.target.value;
    if (zip.length == 5) {
      setZipcode(zip);
      AddressService.getSalesTaxRate({ "zipcode": zip })
        .then((res) => {
          const rate = parseFloat(res.data.data).toFixed(2);
          setTaxRate(rate);
          setTaxAmount((cartSubTotal * rate / 100).toFixed(2));
        })
    }
  }

  return (
    <div className="">
      <section className="hero_section">
        <div className="mx-md-auto">
          <h1 style={{ width: '875px' }}>Checkout</h1>
        </div>
      </section>

      <div className="px-3" style={{ width: '100vw' }}>
        <section className="d-flex flex-column mt-5 mb-4 mx-auto" style={{ maxWidth: '500px' }}>
          <h2 className="text-black fs-3 fst-normal fw-bold">Billing details</h2>
          <form ref={formSectionRef}>
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex flex-column w-50 me-3 me-sm-5">
                <label className="fw-normal">First name <span className="text-danger fw-bold">*</span></label>
                <input className="form-control" type="text" name="firstName" id="firstName" required
                  value={firstName} onChange={(ev) => setFirstName(ev.target.value)} />
              </div>
              <div className="d-flex flex-column w-50">
                <label className="fw-normal">Last name <span className="text-danger fw-bold">*</span></label>
                <input className="form-control" type="text" name="lastName" id="lastName" required
                  value={lastName} onChange={(ev) => setLastName(ev.target.value)} />
              </div>
            </div>

            <div className="d-flex flex-column">
              <label className="fw-normal">Club (optional)</label>
              <input type="text" className="form-control mb-3" name="clubName" id="clubName" value={clubName} onChange={(ev) => setClubName(ev.target.value)}  />

              <label className="fw-normal">Country / Region <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control mb-3 w-100" required
                style={{ width: '250px', height: '25.19px', }}
                name="county" id="county" value={county} onChange={(ev) => setCounty(ev.target.value)} />

              <label className="fw-normal">Street address <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control mb-3" name="line1" id="line1" required
                value={line1} onChange={(ev) => setLine1(ev.target.value)} />
              <input type="text" className="form-control mb-3" name="line2" id="line2" value={line2} onChange={(ev) => setLine2(ev.target.value)}  />


              <label className="fw-normal">Town / City <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control mb-3" name="city" id="city" required
                value={city} onChange={(ev) => setCity(ev.target.value)} />

              <label className="fw-normal">State <span className="text-danger fw-bold">*</span></label>
              <select className="form-control w-100 mb-3" required style={{ width: '250px' }}
                name="state" id="state" value={state} onChange={(ev) => setState(ev.target.value)}
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>

              <label className="fw-normal">ZIP Code <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control mb-3" name="zipcode" id="zipcode" required
                maxlength="5" value={zipcode} onChange={handleZipcodeChange} />


              <label className="fw-normal">Phone <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control mb-3" name="phone" id="phone" required
                value={phone} onChange={(ev) => setPhone(ev.target.value)} />

              <label className="fw-normal">Email address <span className="text-danger fw-bold">*</span></label>
              <input type="text" className="form-control" name="email" id="email" value={email} required
                onChange={(ev) => setEmail(ev.target.value)} />
            </div>
          </form>
        </section>

        <section className="d-flex flex-column mt-5 mb-4 mx-auto" style={{ maxWidth: '500px' }}>
          <h2 className="text-black fs-3 fst-normal fw-bold">Your Order</h2>
          <div className="rounded-3 p-2" style={{ border: 'solid #f6f5f8 1px' }}>
            <table>
              <thead style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '30px' }}>
                <tr>
                  <th>Product</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {
                  cartItems.map((item, idx) => (
                  <tr style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '30px' }}>
                      <td className="pe-5">
                        {
                          item.product == "whiteSticker" ? `Canoe Numbers - White Background/Black Letters Number ${item.canoeNumber}` :
                            `Canoe Numbers - Back Background/White Letters Number ${item.canoeNumber}`
                        }
                        <span className="ms-2 fw-bold">x {item.quantity}</span>
                      </td>
                      <td>${money(item.quantity * getUnitPrice(item.quantity))}</td>
                    </tr>
                  ))
                }

                <tr style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '30px' }}>
                  <td className="fw-bold">Subtotal</td>
                  <td className="fw-bold">${money(cartSubTotal)}</td>
                </tr>
                <tr style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '30px' }}>
                  <td className="fw-bold">Shipping</td>
                  <td>Flat rate $14.20</td>
                </tr>
                {
                  taxRate > 0 &&
                  <tr style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '30px' }}>
                    <td className="fw-bold">Tax</td>
                    <td className="fw-bold">${ money(taxAmount) }</td>
                  </tr>
                }
                <tr style={{ color: '#4d4d4d', height: '30px' }}>
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">${ money(cartSubTotal + taxAmount + 14.20) }</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="d-flex flex-column mt-5 mb-4 mx-auto" style={{ maxWidth: '500px', backgroundColor: '#edebf0', color: '#4d4d4d' }}>
          <h3 className="fs-5 fw-normal fst-normal p-3 fw-medium" style={{ color: '#4d4d4d' }}>Credit Card</h3>
          <div className="m-3 p-3 position-relative" style={{ backgroundColor: '#dcd7e2' }}>
            <div className="d-flex flex-column mb-3">
              <label className="fw-normal pb-2 fw-medium">Card Number <span className="text-danger fw-bold">*</span></label>
              <CreditCardNumber
                type="text"
                id="cardNumber" name="cardNumber"
                value={cardNumber} onChange={(ev) => setCardNumber(ev.target.value)}
                className="form-control border-0" required
                placeholder="1234 1234 1234 1234"
                style={{
                  backgroundImage: 'url(/scora/dist/img/credit-card.svg)',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right center',
                  backgroundOrigin: 'content-box'
                }}
              />
            </div>

            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex flex-column w-50 me-5">
                <label className="fw-normal pb-2 fw-medium">Expiry Date <span className="text-danger fw-bold">*</span></label>
                <CreditCardMonthYear id="expiration" name="expiration" value={expiration} required
                  onChange={(ev) => setExpiration(ev.target.value)} className="form-control border-0" type="text" placeholder="MM/YY" />
                { /*
                <input id="expiration" name="expiration" value={expiration} required
                  onChange={(ev) => setExpiration(ev.target.value)} className="form-control border-0" type="text" placeholder="MM/YY" />
                 */ }
              </div>
              <div className="d-flex flex-column w-50">
                <label className="fw-normal pb-2 fw-medium">Card Code (CVC) <span className="text-danger fw-bold">*</span></label>
                <input id="cvc" name="cvc" className="form-control border-0" value={cvc} required
                  onChange={(ev) => setCvc(ev.target.value)} type="text" placeholder="CVC" />
              </div>
            </div>
          </div>
          <div className="mt-4 p-3" style={{ borderTop: 'solid #e0dbe4 1px' }}>
            <p className="fw-medium">
              Your personal data will be used to process your order, support your experience throughout this website,
              and for other purposes described in our <a href="https://precisionservicesgroup.com/privacy-policy.html" target="_blank" className="text-decoration-none" style={{ color: '#83A096' }}>privacy policy</a>.
            </p>
            <div className="mt-4 d-flex justify-content-end">
              <button className="scoraBtn py-2 px-4 rounded-5" onClick={placeOrder} ref={placeOrderBtn}>PLACE ORDER</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}